import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  template: `
    <footer class="bg-white dark:bg-[#003249] border-t dark:border-[#007ea7]/50">
      <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div class="flex items-center gap-3">
              <img src="https://firebasestorage.googleapis.com/v0/b/arrisfinance.firebasestorage.app/o/arris-finance-logo.png?alt=media&token=89c9b8b6-0ce4-4b08-b042-a6dc49400690" alt="Arris Finance Logo" class="h-10 w-auto">
              <div class="flex flex-col leading-none">
                <span class="text-xl text-gray-800 dark:text-[#ccdbdc] font-cal-sans">Arris</span>
                <span class="text-xl text-gray-800 dark:text-[#ccdbdc] -mt-1 font-cal-sans">Finance</span>
              </div>
            </div>
            <p class="mt-4 text-sm text-gray-500 dark:text-[#8dcbce]">Peer-to-Peer property lending platform. Regulated by the FCA in the UK.</p>
          </div>
          <div>
            <h3 class="text-sm font-semibold text-gray-900 dark:text-white tracking-wider uppercase">Navigation</h3>
            <ul class="mt-4 space-y-2">
              @for (item of navItems(); track item.path) {
                <li><a [routerLink]="item.path" class="text-base text-gray-500 dark:text-[#8dcbce] hover:text-gray-900 dark:hover:text-white">{{ item.label }}</a></li>
              }
            </ul>
          </div>
          <div>
            <h3 class="text-sm font-semibold text-gray-900 dark:text-white tracking-wider uppercase">Legal</h3>
            <ul class="mt-4 space-y-2">
              <li><a href="#" class="text-base text-gray-500 dark:text-[#8dcbce] hover:text-gray-900 dark:hover:text-white">Privacy Policy</a></li>
              <li><a href="#" class="text-base text-gray-500 dark:text-[#8dcbce] hover:text-gray-900 dark:hover:text-white">Terms of Service</a></li>
            </ul>
          </div>
        </div>
        <div class="mt-8 border-t border-gray-200 dark:border-[#007ea7]/50 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p class="text-base text-gray-400 dark:text-gray-500">&copy; {{ currentYear }} Arris Finance. All rights reserved.</p>
          <div class="flex space-x-6 mt-4 sm:mt-0">
            <a href="#" class="text-gray-400 hover:text-gray-500"><span class="sr-only">Facebook</span><i class="fa-brands fa-facebook-f"></i></a>
            <a href="#" class="text-gray-400 hover:text-gray-500"><span class="sr-only">Instagram</span><i class="fa-brands fa-instagram"></i></a>
            <a href="#" class="text-gray-400 hover:text-gray-500"><span class="sr-only">X</span><i class="fa-brands fa-x-twitter"></i></a>
          </div>
        </div>
      </div>
    </footer>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  navItems = input<{ path: string; label: string }[]>([]);
  currentYear = new Date().getFullYear();
}
